import React, { useEffect } from 'react';
import PageSeo from '@/seo/PageSeo';
import { DEFAULT_META_DESCRIPTION, getHomeJsonLd } from '@/seo/site';
import Header from '../components/Headers/Header';
import Container from '../components/Home/Container';
import Container2 from '../components/Home/Container2';
import SearchBar from '../modules/search/searchBar/SearchBar';
import BlogHome from '../components/Home/BlogHome';
import HomeStats from '../components/Home/HomeStats';
import RecentSearches from '../components/Home/RecentSearches';
import useText from '@/hooks/useText';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from '@heroicons/react/24/solid';
import { userAppContext } from '@/context/Context';
import { UserContext } from '@/types';
import { buildAllResultsSearch, resolveSearchSource } from '@/utils/allResultsSearch';
import { trackEvent } from '@/utils/analytics';

function Home() {
  const searchPlaceholder = useText('home.hero.search_placeholder');
  const { groups } = userAppContext as unknown as UserContext;
  const isAcademic = groups?.includes('ROLE_ACADEMIC');

  const handleBrowseAll = () => {
    const source = resolveSearchSource({ groups: isAcademic ? ['ROLE_ACADEMIC'] : [] });
    return `/search${buildAllResultsSearch(source).search}`;
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('scroll-reveal-visible');
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0 },
    );
    const els = document.querySelectorAll('.scroll-reveal');
    els.forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  const heroContent = (
    <>
      <Container>
        <div className="home-hero-search-wrap">
          <div className="home-hero-search">
            <SearchBar placeholder={searchPlaceholder} />
            <div className="home-hero-search-meta">
              <RecentSearches />
              <div className="home-hero-browse-all">
                <Link
                  to={handleBrowseAll()}
                  className="text-blue font-bold"
                  onClick={() =>
                    trackEvent({
                      name: 'navigation_click',
                      buttonId: 'home_browse_all',
                      label: 'Browse all',
                      page: 'home',
                      section: 'hero',
                      feature: 'navigation',
                      eventCategory: 'navigation',
                    })
                  }
                >
                  Browse All
                </Link>
                <ArrowRightIcon className="w-4 h-4 text-blue" />
              </div>
            </div>
          </div>
        </div>
      </Container>
      <section className="home-stats-wrapper home-stats-overlap">
        <HomeStats />
      </section>
    </>
  );

  return (
    <React.Fragment>
      <PageSeo
        title="Gene-Disease Association Database | DISGENET"
        description={DEFAULT_META_DESCRIPTION}
        path="/"
        jsonLd={getHomeJsonLd()}
      />
      <Header>{heroContent}</Header>
      <div className="home-main-content">
        <div className="container home-features">
          <div style={{ marginBottom: '80px' }}>
            <Container2 />
          </div>
          <div style={{ marginBottom: '150px' }}>
            <BlogHome />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default Home;
